// extracted by mini-css-extract-plugin
export default {"button":"BackToTop_button__qYWSH","show":"BackToTop_show__0MnSC","icon":"BackToTop_icon__aVDf+"};